// function HomepageAbout() {
//   return (
//     <section className="relative h-screen flex items-center justify-center overflow-hidden">

//       <div className="container-width section-padding w-full text-center pb-40">
//         <h1 className="sm:text-2xl md:text-2xl lg:text-8xl xl:text-7xl font-bold tracking-[0.15em] text-secondary/90 uppercase leading-none">
//           <div>Tamar Valley</div>
//           <div>Business</div>
//           <div>Association</div>
//         </h1>
//       </div>
      
//       {/* Scroll Indicator */}
//       <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
//         <div className="w-[1px] h-24 bg-gradient-to-b from-secondary to-transparent" />
//       </div>
//     </section>
//   )
// }

// export default HomepageAbout

// import { ImageWithFallback } from '../../assets/images/exeter-market.jpg';

export function AboutSection() {
  return (
    <section id="about" className="py-40 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto space-y-32">
        {/* Who We Are - Text 30% : Image 70% */}
        <div className="grid grid-cols-1 lg:grid-cols-10 gap-12 items-center">
          {/* Text Content - 3 columns */}
          <div className="lg:col-span-3 space-y-8 animate-slide-in-left">
            <h2 className="text-4xl md:text-5xl tracking-[0.2em] text-secondary/80 uppercase">
              Who We Are
            </h2>

            <p className="text-base leading-relaxed text-white/80 tracking-wide">
              The Tamar Valley Business Association (TVBA) is a non-profit organisation nestled in the picturesque Tamar Valley region of Northern Tasmania. Our primary objective is to foster and support local businesses within our community.
            </p>

            <a 
              href="/about" 
              className="inline-block text-sm tracking-[0.3em] text-secondary/70 hover:text-secondary transition-all duration-500 uppercase group"
            >
              Learn More
              <span className="inline-block ml-2 group-hover:translate-x-2 transition-transform duration-500">→</span>
            </a>
          </div>

          {/* Image - 7 columns */}
          <div className="lg:col-span-7 animate-fade-in-delayed">
            <div className="relative overflow-hidden aspect-[16/9] bg-black/20">
              <a href="/about">
                <img
                  src="/images/batman-bridge.jpg"
                  alt="Batman Bridge"
                  className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity duration-700"
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>

 
      </div>
    </section>
  );
}
